module.exports = __webpack_public_path__ + "static/media/offgamers.a914f673.png";